import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { FeatureTabHostComponent } from './feature-tab-host.component';
import { FeatureTabsComponent } from './feature-tabs.component';
import { FeatureDynamicHostDirective } from './feature-dynamic-host.directive';
import { FeatureTabsActionsDirective } from './feature-tabs-actions.directive';

@NgModule({
  declarations: [
    FeatureTabHostComponent,
    FeatureTabsComponent,
    FeatureDynamicHostDirective,
    FeatureTabsActionsDirective,
  ],
  imports: [CommonModule, MatButtonModule, MatSelectModule],
  exports: [FeatureTabHostComponent, FeatureTabsComponent, FeatureDynamicHostDirective, FeatureTabsActionsDirective],
})
export class FeatureTabLayoutModule {}
